import CornerBlur from "./CornerBlur";
import {tileViewerPlotColors} from "../../../utils/const";
import {drawLine} from "../utils/map_utils";

class CornerBlurText extends CornerBlur {
    id = "corner-blur-text";
    label = "Corner Blur Text";
    defaultVisible = this.props.tileViewerState[this.id];

    process = (val, xc, y, x_shift, y_shift, widthOfRect) => {
        let {tile_width, tile_height, uperpixel} = this.props.slide;
        //Text
        const textVal = Math.floor(val * 1000)
        drawLine((xc + x_shift + widthOfRect / 2) * (tile_width * uperpixel),
            (y + y_shift - widthOfRect / 2) * (tile_height * uperpixel), 1, this.layer.getSource(), textVal,
            1, tileViewerPlotColors.fftRatioCleanColor, "", this.props.textColor, this.props.textSize);
    }
}

export default CornerBlurText;
